'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useEffect } from 'react';
import t from 'tiny-warning';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t.push.apply(t, n);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function deprecatedComponent({ root: o, displayName: p, description: c }) {
    let i = forwardRef((r, i)=>(useEffect(()=>{
            t(r.__dangerouslySuppressWarning, `${p} is Deprecated. ${c}`);
        }, [
            r.__dangerouslySuppressWarning
        ]), jsx(o, _object_spread_props(_object_spread({}, r), {
            ref: i
        }))));
    return i.displayName = `deprecated(${o.displayName})`, i;
}

export { deprecatedComponent };
